module.exports = __webpack_public_path__ + "img/ffsinvate-right.0b61c67.png";